import request from '@/utils/http'
import { SRM, SRM_FILE } from '../constant/constant.js'

// 查询
export const getSpotCheckInfo = data => {
    return request({
        url: `${SRM}/supplierSpotCheckInfo/queryPage`,
        method: 'post',
        data,
    })
}

// 导出
export const exportSpotCheckInfo = data => {
    return request({
        url: `${SRM_FILE}/supplierSpotCheckInfo/export`,
        method: 'post',
        data,
    })
}

// 删除
export const deleteSpotCheckInfo = data => {
    return request({
        url: `${SRM}/supplierSpotCheckInfo/deleteBatch`,
        method: 'post',
        data,
    })
}

// 点检
export const submitSpotCheckInfo = data => {
    return request({
        url: `${SRM}/supplierSpotCheckInfo/submit`,
        method: 'post',
        data,
    })
}

// 点检文件上传
export const saveSpotCheckFile = data => {
    return request({
        url: `${SRM}/supplierSpotCheckInfo/saveSpotCheckFile`,
        method: 'post',
        data,
    })
}

// 查询点检数据的审批详情
export const selectByAuditId = data => {
    return request({
        url: `${SRM}/supplierSpotCheckInfo/selectByAuditId`,
        method: 'get',
        params: data,
    })
}
